import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header.tsx';
import Footer from './components/Footer.tsx';
import ScrollToTop from './components/ScrollToTop.tsx';
import Home from './pages/Home.tsx';
import Properties from './pages/Properties.tsx';
import About from './pages/About.tsx';
import Contact from './pages/Contact.tsx';
import WhyThanjavur from './pages/WhyThanjavur.tsx';
import CholaGreens from './pages/CholaGreens.tsx';
import './App.css';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App relative">
        <Header />
        <main className="relative">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/properties" element={<Properties />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/why-thanjavur" element={<WhyThanjavur />} />
            <Route path="/projects/chola-greens" element={<CholaGreens />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;